<header role="banner">
  <uiowa-header
    [applicationName]="applicationName"
    [externalLinks]="externalLinks"
    [internalRoutes]="internalRoutes"
    [user]="user">
  </uiowa-header>
</header>
<main role="main" class="w-100 h-100 flex-fill p-0 overflow-auto">
    <div class="loading-overlay flex-fill d-flex align-items-center justify-content-center mt-3" *ngIf="loading">
        <div class="d-flex">
            <uiowa-ring></uiowa-ring>
        </div>
    </div>
    <router-outlet *ngIf="!loading"></router-outlet>
</main>
<footer role="contentinfo">
  <app-footer></app-footer>
</footer>
<session-expiration-alert [startTimer]="startTimer"></session-expiration-alert>
